
































































































































































































































import api from '@/services/api';
import {Component, Vue, Prop} from 'vue-property-decorator';
import UserProfile from '@/classes/UserProfile';
import {phoneValidator, phoneFormatter} from '@/services/inputTools';
import JobCorpsCenter from '@/classes/JobCorpsCenter';
import { IJobCorpsCenterControllerRequest, IJobCorpsCenterControllerResponse } from '@/classes/ControllerInterface/JobCorpsCenterController';

@Component
export default class CenterEdit extends Vue {
    @Prop({default: -1}) public id!: string | number;

    public jobCorpsCenter = new JobCorpsCenter();

    public userSelected: UserProfile | undefined = new UserProfile();

    public disableButton: boolean = false;

    public created() {
        this.updateForm();
    }

    public updateForm() {
        if (this.$props.id) {
            const jobCorpsCenters: JobCorpsCenter[] = this.$store.getters.getJobCorpsCenters;
            const loader = new Promise((resolve, reject) => {
                if (jobCorpsCenters.length === 0) {
                    this.$store.dispatch('loadCenters')
                        .then(resolve)
                        .catch(reject);
                } else {
                    resolve();
                }
            });
            loader.then(() => {
                const foundCenter = this.$store.getters.getJobCorpsCenterById(this.$props.id);
                if (undefined !== foundCenter) {
                    this.jobCorpsCenter = foundCenter;
                    this.jobCorpsCenter.phoneNumber = phoneFormatter(this.jobCorpsCenter.phoneNumber, {});
                    this.jobCorpsCenter.fax = phoneFormatter(this.jobCorpsCenter.fax, {});
                }
            });
        }
    }

    get instructorList(): UserProfile[] {
        const list: UserProfile[] | undefined = this.$store.getters.getInstructorList;
        if (list !== undefined) {
            return list.sort((a: UserProfile, b: UserProfile) => {
                if (a.firstName !== undefined && b.firstName !== undefined) {
                    if (a.firstName < b.firstName) {
                        return -1;
                    }
                    if (a.firstName > b.firstName) {
                        return 1;
                    }
                }
                return 0;
            })
                .filter((b: UserProfile) => b.active);
        } else {
            return [];
        }
    }

    get coordinatorList(): UserProfile[] {
        const list: UserProfile[] | undefined = this.$store.getters.getFieldCoordinatorList;
        if (list !== undefined) {
            return list.sort((a: UserProfile, b: UserProfile) => {
                if (a.firstName !== undefined && b.firstName !== undefined) {
                    if (a.firstName < b.firstName) {
                        return -1;
                    }
                    if (a.firstName > b.firstName) {
                        return 1;
                    }
                }
                return 0;
            })
                .filter((b: UserProfile) => b.active);
        } else {
            return [];
        }
    }

    public checkInputs(): string | boolean {
        const errors: string [] = [];
        if (this.jobCorpsCenter.phoneNumber === undefined || this.jobCorpsCenter.phoneNumber === null ||
            (phoneValidator(this.jobCorpsCenter.phoneNumber.toString()) === false)) {
            errors.push('Please enter a valid Phone Number.');
        }
        if (this.jobCorpsCenter.fax === undefined || this.jobCorpsCenter.fax === null ||
            (phoneValidator(this.jobCorpsCenter.fax.toString()) === false)) {
            errors.push('Please enter a valid Fax.');
        }
        if (errors.length > 0) {
            return 'Please correct the following: \n\n' + errors.reduce((a: string, e: string) => a + '\n' + e);
        } else {
            return false;
        }
    }

    public sendForm() {
        if (this.checkInputs()) {
            alert(this.checkInputs());
        } else {
            this.disableButton = true;
            api().post('center/edit', { center: this.jobCorpsCenter } as IJobCorpsCenterControllerRequest)
                .then((res) => {
                    const response: IJobCorpsCenterControllerResponse | undefined = res.data;
                    if (response && response.success && response.center && response.center.id) {
                    this.$store.dispatch('loadCenters');
                    alert(response.message);
                    this.$router.push('/administration/center/profile/' + response.center.id);
                    } else {
                    if (response && response.message) {
                        alert(response.message);
                    } else {
                        throw new Error();
                    }
                    }
                })
                .catch((response) => {
                    alert('Something went wrong.');
                });
        }
    }

    public deactivateCenter() {
        if (confirm('Do you want to deactivate ' + this.jobCorpsCenter.name + '?')) {
            api().post('center/deactivate', {
                centerId: this.id
            } as IJobCorpsCenterControllerRequest)
                .then((response) => {
                    if (response.data.success) {
                        this.$store.dispatch('loadCenters')
                            .finally(() => {
                                alert(response.data.message);
                                this.updateForm();
                            });
                    } else {
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    alert(error.response.data.message);
                });
        }
    }

    public reactivateCenter() {
        if (confirm('Do you want to reactivate ' + this.jobCorpsCenter.name + '?')) {
            api().post('center/reactivate', {
                centerId: this.id
            } as IJobCorpsCenterControllerRequest)
                .then((response) => {
                    if (response.data.success) {
                        this.$store.dispatch('loadCenters')
                            .finally(() => {
                                alert(response.data.message);
                                this.updateForm();
                            });
                    } else {
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    alert(error.response.data.message);
                });
        }
    }

    public getUserProfileName(id: number) {
        const user = this.$store.getters.getUserProfileById(id);
        if (user) {
            return user.getFullName();
        } else {
            return '';
        }
    }

    public getUserProfileNamePlusState(id: number) {
        const user = this.$store.getters.getUserProfileById(id);
        if (user) {
            return `${user.lastName ? user.lastName : ''}, ${user.firstName ? user.firstName : ''} ${user.active ? '(Active)' : ' (Inactive)'}`;
        } else {
            return '';
        }
    }

}
